<div
  class="bg-white rounded-medium py-6 px-4 w-[287px] xl:w-full h-full gap-6 flex flex-col justify-between"

>
  <div class="flex flex-col gap-6">
    <div [ngClass]="{'bg-gray-100' : comingSoon, 'bg-[#FFE6DC]' : !comingSoon }" class="w-full h-[152px] flex justify-center items-center rounded-lg">
      @if(imagePath) {
        <img class="object-fit h-[128px]" [src]="imagePath" alt="service image placeholder">
      }
    </div>
    <div class="flex flex-col gap-2">
      <h3 class="h3 text-black">
        @if(serviceTypeString !== undefined && serviceTypeString !== 'undefined' && !comingSoon) {
          <a [routerLink]="[localizedRoute('/services/' + serviceTypeString, this.envInjector)]" [queryParams]="{property: this.propertyCode}" queryParamsHandling="merge">{{title}}</a>
        } @else {
          <span>{{title}}</span>
        }
      </h3>
      <p class="text-gray-700">{{subtitle}}</p>
    </div>
  </div>
  @if(ctaTitle && !comingSoon) {
    <div class="flex">
      <button (click)="goServiceDetailsPage()" [disabled]="disableButton" class="btn-secondary flex items-center gap-2">{{ctaTitle}}</button>
    </div>
  }
  @if(comingSoon) {
    <div class="flex">
      <button disabled class="py-[0.375rem] px-2 rounded-lg font-semibold text-sm bg-primary-100 text-primary-700">Σύντομα κοντά σου</button>
    </div>
  }
</div>
